module.exports = __webpack_public_path__ + "static/media/logo.c4fb3d06.png";